import { CampaignEmployee } from '@models/Campaign'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { CAMPAIGN_EMPLOYEE_URL } from '@utils/urls'

const fetchCampaignEmployees = (params: TableParams) =>
  SBAPI.FetchPaginated<CampaignEmployee[]>(CAMPAIGN_EMPLOYEE_URL, params)

const fetchCampaignEmployeeById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<CampaignEmployee>(`${CAMPAIGN_EMPLOYEE_URL}/${id}`, params)

const createCampaignEmployee = (campaignEmployee: CampaignEmployee) =>
  SBAPI.Post(CAMPAIGN_EMPLOYEE_URL, campaignEmployee)

const updateCampaignEmployee = (campaignEmployee: CampaignEmployee) =>
  SBAPI.Put(`${CAMPAIGN_EMPLOYEE_URL}/${campaignEmployee.id}`, campaignEmployee)

const deleteCampaignEmployee = (campaignEmployee: CampaignEmployee) =>
  SBAPI.Delete(`${CAMPAIGN_EMPLOYEE_URL}/${campaignEmployee.id}`)

export {
  createCampaignEmployee,
  deleteCampaignEmployee,
  fetchCampaignEmployeeById,
  fetchCampaignEmployees,
  updateCampaignEmployee,
}
